import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN } from './cardCoversSpotlight.constants.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { maybeWaitForPremiumModal } from './maybeWaitForPremiumModal.tsx';

export const loadWeeklyModeSpotlightSeen =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().timeline.weeklyModeSpotlightSeen === 'boolean') {
			return;
		}

		try {
			const weeklyModeSpotlightSeen = await getUserProperty<boolean>(
				accountId,
				TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN,
			);

			const state = getState();

			setState({
				timeline: {
					...state.timeline,
					weeklyModeSpotlightSeen,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					timeline: {
						...state.timeline,
						weeklyModeSpotlightSeen: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.timeline.weekly-mode-spotlight',
				`Failed to get user property with key: ${TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN}`,
				error instanceof Error ? error : undefined,
			);
		}
	};

export const setWeeklyModeSpotlightSeen =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			timeline: {
				...state.timeline,
				weeklyModeSpotlightSeen: true,
			},
		});

		try {
			await setUserProperties(accountId, TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.timeline.weekly-mode-spotlight',
				`Failed to set user property with key: ${TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
